import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StatisticsDto } from "../dtos/statistics.dto";
import { ApiService } from "./base/api.service";
import { CreatureWebFilterDto } from "../dtos/creature.web.filter.dto";
import { CreatureLiteWebDto } from "../dtos/creature.lite.web.dto";
import { CreatureWebDto } from "../dtos/creature.web.dto";
import { CreatureBreedingWebDto } from "../dtos/creature.breeding.web.dto";

@Injectable({
    providedIn: 'root',
})
export class CreaturesService {

    private readonly baseUrl = 'creatures/';

    constructor(private apiService: ApiService) { }

    getByFilter(filter: CreatureWebFilterDto): Observable<CreatureLiteWebDto[]> {
        return this.apiService.post<CreatureLiteWebDto[]>(this.baseUrl + 'filter', filter);
    }

    getById(id: string): Observable<CreatureWebDto> {
        return this.apiService.get<CreatureWebDto>(this.baseUrl + id);
    }

    сheckAbilityToBreedById(id: string): Observable<CreatureWebDto> {
        return this.apiService.put<CreatureWebDto>(this.baseUrl + id + '/check-ability-to-breed', {});
    }

    getBreedingByFilter(): Observable<CreatureBreedingWebDto[]> {
        return this.apiService.post<CreatureBreedingWebDto[]>(this.baseUrl + 'breeding/filter', {});
    }
}